export const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: string): string | null => {
  return localStorage.getItem(key);
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const clearAllFromLocalstorage = () => {
  localStorage.clear();
};

export const removeAuthStorage = () => {
  removeLocalStorage('access_token');
  removeLocalStorage('refresh_token');
};
